import {
  OsmMonitoringType,
  OsmMonitoringResult,
  OsmMonitoringStatus,
  OsmMonitoringEvaluationAction,
} from 'api';

export const getOsmMonitoringTypeName = (type: OsmMonitoringType): string => {
  const typeNames: Record<OsmMonitoringType, string> = {
    [OsmMonitoringType.Osm]: 'OSM monitoring',
    [OsmMonitoringType.Eor]: 'EOR monitoring',
    [OsmMonitoringType.Rem]: 'REM monitoring',
  };
  return typeNames[type] ?? '-';
};

export const getOsmMonitoringResultName = (result: OsmMonitoringResult): string => {
  const resultNames: Record<OsmMonitoringResult, string> = {
    [OsmMonitoringResult.Phase0]: 'Phase 0',
    [OsmMonitoringResult.Phase1]: 'Phase 1',
    [OsmMonitoringResult.Phase2]: 'Phase 2',
    [OsmMonitoringResult.Phase3]: 'Phase 3',
    [OsmMonitoringResult.Phase4]: 'Phase 4',
    [OsmMonitoringResult.Standard]: 'Standard',
    [OsmMonitoringResult.NonStandard]: 'Non-Standard',
    [OsmMonitoringResult.Active]: 'Active',
    [OsmMonitoringResult.SuspendedForStandards]: 'Suspended for Standards',
    [OsmMonitoringResult.SuspendedForVolume]: 'Suspended for Volume',
  };
  return resultNames[result] ?? '-';
};

export const getOsmMonitoringStatusName = (status: OsmMonitoringStatus): string => {
  const statusNames: Record<OsmMonitoringStatus, string> = {
    [OsmMonitoringStatus.Current]: 'Current',
    [OsmMonitoringStatus.Archived]: 'Archived',
    [OsmMonitoringStatus.Deleted]: 'Deleted',
  };
  return statusNames[status] ?? '-';
};

export const getOsmMonitoringEvaluationActionName = (
  action: OsmMonitoringEvaluationAction
): string => {
  const actionNames: Record<OsmMonitoringEvaluationAction, string> = {
    [OsmMonitoringEvaluationAction.Action1]: 'Action 1',
    [OsmMonitoringEvaluationAction.Action2]: 'Action 2',
    [OsmMonitoringEvaluationAction.Action3]: 'Action 3',
  };
  return actionNames[action] ?? '-';
};
